export function drawRoundRect (cxt, x, y, w, h, r, color, lineWidth) {
  cxt.save()
  cxt.translate(x, y)
  pathRoundRect(cxt, w, h, r)
  cxt.lineWidth = lineWidth || 1
  cxt.strokeStyle = color || 'black'
  cxt.stroke()
  cxt.restore()
}
export function pathRoundRect (cxt, w, h, r) {
  cxt.beginPath()
  cxt.arc(w - r, h - r, r, 0, 0.5 * Math.PI)
  cxt.lineTo(r, h)
  cxt.arc(r, h - r, r, 0.5 * Math.PI, Math.PI)
  cxt.lineTo(0, r)
  cxt.arc(r, r, r, Math.PI, 1.5 * Math.PI)
  cxt.lineTo(w - r, 0)
  cxt.arc(w - r, r, r, 1.5 * Math.PI, 2 * Math.PI)
  cxt.lineTo(w, h - r)
  cxt.closePath()
}

// 解决微信二次分享的坑
export function directRightUrl (callback) {
  let { href, origin, pathname, search, hash } = window.location
  let newHref = `${origin}${pathname}${hash}`
  console.log(href, origin, pathname, search, hash, newHref)
  if (newHref !== href) {
    window.location.replace(newHref)
  } else {
    callback()
  }
}

// 检查是否在微信中
export function checkWx () {
  var ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

// 检查是否在支付宝中
export function checkAli () {
  var ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('alipayclient') !== -1
}

export function androidOrIos () {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return 'android'
  } else if (isiOS) {
    return 'ios'
  } else {
    return 'unknown'
  }
}





// WEBPACK FOOTER //
// ./src/utils/tool.js